export class BaseServiceError extends Error {
    _primary_error_code;
    name;
    message;
    meta;
    cause;
    constructor({ name, message, meta, cause, }) {
        super(message);
        this.name = name;
        this._primary_error_code = name;
        this.message = message;
        this.meta = meta;
        this.cause = cause;
    }
}
export class ServiceError extends BaseServiceError {
}
export const isServiceError = (err) => err instanceof Error &&
    "_primary_error_code" in err &&
    typeof err._primary_error_code === "string";
export function createServiceErrorGuard(_primary_error_codes) {
    return (e) => isServiceError(e) && _primary_error_codes.includes(e._primary_error_code);
}
export class NotFoundError extends Error {
}
